import React from 'react';

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
  "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
  "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
  "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
  "Fiji", "Finland", "France",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
  "Haiti", "Honduras", "Hungary",
  "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast",
  "Jamaica", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
  "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway",
  "Oman",
  "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
  "Qatar",
  "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
  "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen",
  "Zambia", "Zimbabwe"
];

// ISO 2-letter mapping for major and common countries
export const COUNTRY_ISO_MAP = {
  "afghanistan": "AF", "albania": "AL", "algeria": "DZ", "andorra": "AD", "angola": "AO",
  "argentina": "AR", "armenia": "AM", "australia": "AU", "austria": "AT", "azerbaijan": "AZ",
  "bahamas": "BS", "bahrain": "BH", "bangladesh": "BD", "barbados": "BB", "belarus": "BY",
  "belgium": "BE", "belize": "BZ", "benin": "BJ", "bhutan": "BT", "bolivia": "BO",
  "bosnia and herzegovina": "BA", "botswana": "BW", "brazil": "BR", "brunei": "BN", "bulgaria": "BG",
  "cambodia": "KH", "cameroon": "CM", "canada": "CA", "chile": "CL", "china": "CN",
  "colombia": "CO", "costa rica": "CR", "croatia": "HR", "cuba": "CU", "cyprus": "CY",
  "czech republic": "CZ", "denmark": "DK", "dominican republic": "DO", "ecuador": "EC",
  "egypt": "EG", "el salvador": "SV", "estonia": "EE", "ethiopia": "ET", "finland": "FI",
  "france": "FR", "georgia": "GE", "germany": "DE", "ghana": "GH", "greece": "GR",
  "guatemala": "GT", "haiti": "HT", "honduras": "HN", "hungary": "HU", "iceland": "IS",
  "india": "IN", "bharat": "IN", "भारत": "IN", "in": "IN", "indonesia": "ID", "iran": "IR", "iraq": "IQ", "ireland": "IE",
  "israel": "IL", "italy": "IT", "ivory coast": "CI", "jamaica": "JM", "japan": "JP",
  "jordan": "JO", "kazakhstan": "KZ", "kenya": "KE", "kuwait": "KW", "kyrgyzstan": "KG",
  "laos": "LA", "latvia": "LV", "lebanon": "LB", "libya": "LY", "lithuania": "LT",
  "luxembourg": "LU", "madagascar": "MG", "malaysia": "MY", "maldives": "MV", "mali": "ML",
  "malta": "MT", "mexico": "MX", "moldova": "MD", "monaco": "MC", "mongolia": "MN",
  "montenegro": "ME", "morocco": "MA", "myanmar": "MM", "namibia": "NA", "nepal": "NP",
  "netherlands": "NL", "new zealand": "NZ", "nicaragua": "NI", "nigeria": "NG", "norway": "NO",
  "oman": "OM", "pakistan": "PK", "palestine": "PS", "panama": "PA", "paraguay": "PY",
  "peru": "PE", "philippines": "PH", "poland": "PL", "portugal": "PT", "qatar": "QA",
  "romania": "RO", "russia": "RU", "rwanda": "RW", "saudi arabia": "SA", "senegal": "SN",
  "serbia": "RS", "singapore": "SG", "slovakia": "SK", "slovenia": "SI", "south africa": "ZA",
  "south korea": "KR", "korea, south": "KR", "korea, north": "KP", "spain": "ES", "sri lanka": "LK",
  "sudan": "SD", "sweden": "SE", "switzerland": "CH", "syria": "SY", "taiwan": "TW",
  "tajikistan": "TJ", "tanzania": "TZ", "thailand": "TH", "tunisia": "TN", "turkey": "TR",
  "uganda": "UG", "ukraine": "UA", "united arab emirates": "AE", "uae": "AE",
  "united kingdom": "GB", "uk": "GB", "united states": "US", "usa": "US",
  "uruguay": "UY", "uzbekistan": "UZ", "vatican city": "VA", "venezuela": "VE",
  "vietnam": "VN", "yemen": "YE", "zambia": "ZM", "zimbabwe": "ZW"
};

/**
 * Returns flag emoji for country code or country name
 */
export const getCountryFlag = (country) => {
  if (!country || typeof country !== 'string') return '🌐';
  const trimmed = country.trim();
  if (trimmed.length === 2) {
    const codePoints = trimmed.toUpperCase().split('').map(c => 127397 + c.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }
  const iso = COUNTRY_ISO_MAP[trimmed.toLowerCase()];
  if (iso) {
    const codePoints = iso.toUpperCase().split('').map(c => 127397 + c.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }
  return '🌐';
};

/**
 * Clean reusable CountryBadge component for all admin list views
 */
export const CountryBadge = ({ country, className = '' }) => {
  if (!country) {
    return (
      <span className={`inline-flex items-center gap-1 text-slate-400 italic text-xs ${className}`}>
        <span>—</span>
        <span>Not Set</span>
      </span>
    );
  }
  const cleanCountry = (country === 'भारत' || country.toString().toLowerCase() === 'bharat') ? 'India' : country;
  const flag = getCountryFlag(cleanCountry);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold bg-slate-100 text-slate-700 border border-slate-200/80 whitespace-nowrap shadow-2xs ${className}`}>
      <span className="text-sm leading-none">{flag}</span>
      <span>{cleanCountry}</span>
    </span>
  );
};
